export default function ProctorsPage() {
    return (
        <div className="bg-white p-4 rounded shadow">
            <h2 className="text-lg font-bold">Proctors</h2>
            <p className="text-sm text-gray-600 mt-2">Manage proctors here.</p>
        </div>
    );
}
